import * as Yup from "yup";

export function inititalValues(user) {
  return {
    email: user? user.email : "",
    resetPasswordToken: user? user.resetPasswordToken : "",
    resetPasswordExpires: user? user.resetPasswordExpires : ""
  };
}

export function validationSchema(t) {
  return Yup.object({
    email: Yup.string()
      .email(t("invalid_email"))
      .required(t("required_field")),
    password: Yup.string()
      .min(8, t("password_min_8_chars"))
      .matches(/[0-9]/, t("password_requires_number"))
      .matches(/[a-z]/, t("password_requires_lowercase"))
      .matches(/[A-Z]/, t("password_requires_uppercase"))
      .matches(/[^\w]/, t("password_requires_symbol"))
      .required(t("required_field")),
    repeatPassword: Yup.string()
      .required(t("required_field"))
      .oneOf([Yup.ref("password")], t("passwords_must_match")),
  });
}
